"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningTimeout = void 0;
const literals_1 = __importDefault(require("../literals"));
const trackingActions = __importStar(require("../tracking"));
const useWarningTimeout = (props) => {
    const navigate = () => {
        props.redirect.goToPublic();
    };
    const onClick = () => {
        props.tracker?.track(trackingActions.TIMEOUT_MODAL_EXTEND_SESSION_BUTTON);
        props.handleRefresh();
    };
    const onLinkClick = () => {
        props.tracker?.track(trackingActions.TIMEOUT_MODAL_LOGOUT_LINK);
        props.handleFinnish();
    };
    const { translate } = props;
    return {
        countDown: props.countDown,
        navigate,
        onClick,
        onLinkClick,
        isOpen: props.isOpen,
        translations: {
            title: translate(literals_1.default.TIMEOUT.MODAL_WARNING.TITLE),
            description: translate(literals_1.default.TIMEOUT.MODAL_WARNING.DESCRIPTION),
            secondaryText: translate(literals_1.default.TIMEOUT.MODAL_WARNING.SECONDARY_LINK),
            primaryText: translate(literals_1.default.TIMEOUT.MODAL_WARNING.BUTTON_PRIMARY),
        },
    };
};
exports.useWarningTimeout = useWarningTimeout;
//# sourceMappingURL=useWarningTimeout.js.map